import { useState } from "react";

const SVGComponent = ({ data }) => {
    const { first, seconed, third } = data
    const [animationClass, setAnimationClass] = useState('animationClass-base-v')

    return (
        <svg
            width="75%" className="mx-auto" height="100%" viewBox="0 0 560 352"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1={491.5}
                y1={148.509}
                x2={491.5}
                y2={259.509}
                stroke="#28DC9C"
                strokeLinecap="round"
                strokeDasharray="4 6"
            />
            <line
                x1={320.5}
                y1={148.509}
                x2={320.5}
                y2={259.509}
                stroke="#28DC9C"
                strokeLinecap="round"
                strokeDasharray="4 6"
            />
            <line
                x1={157.5}
                y1={148.509}
                x2={157.5}
                y2={259.509}
                stroke="#28DC9C"
                strokeLinecap="round"
                strokeDasharray="4 6"
            />
            <g onMouseOver={() => setAnimationClass('animationClass-v-3')} onMouseLeave={() => setAnimationClass('animationClass-base-v')}>
                <text fill="white" y={197} x={151}>
                    3rd
                </text>
                <foreignObject width="165" fill="white" y={208} x={-12} height="100">
                    <div xmlns="http://www.w3.org/1999/xhtml">
                        {third?.student_first_name || ''} {" "}
                        {third?.student_father_name || ''} {" "}
                        {third?.student_last_name || ''}
                    </div>
                </foreignObject>
                <text fill="white" y={275} x={151} fontSize="12px">
                    {third?.student_grade || ''}
                </text>
                <text fill="#A9F1D7" y={165} x={220} fontSize="12px">
                    {Math.round(third?.total_jump_h) || ''} سم
                </text>
            </g>

            <g onMouseOver={() => setAnimationClass('animationClass-v-2')} onMouseLeave={() => setAnimationClass('animationClass-base-v')}>
                <text fill="white" y={197} x={305}>
                    2rd
                </text>
                <foreignObject width="150" fill="white" y={209} x={165} height="100">
                    <div xmlns="http://www.w3.org/1999/xhtml">
                        {seconed?.student_first_name || ''} {" "}
                        {seconed?.student_father_name || ''} {" "}
                        {seconed?.student_last_name || ''}
                    </div>
                </foreignObject>
                <text fill="white" y={275} x={315} fontSize="12px">
                    {seconed?.student_grade || ''}
                </text>
                <text fill="#A9F1D7" y={165} x={380} fontSize="12px">
                    {Math.round(seconed?.total_jump_h) || ''} سم
                </text>
            </g>

            <g onMouseOver={() => setAnimationClass('animationClass-v-1')} onMouseLeave={() => setAnimationClass('animationClass-base-v')}>
                <text fill="white" y={197} x={485}>
                    1st
                </text>
                <foreignObject width="150" fill="white" y="207" x="335" height="100">
                    <div xmlns="http://www.w3.org/1999/xhtml">
                        {first?.student_first_name || ''} {" "}
                        {first?.student_father_name || ''} {" "}
                        {first?.student_last_name || ''}
                    </div>
                </foreignObject>
                <text fill="white" y={275} x={485} fontSize="12px">
                    {first?.student_grade || ''}
                </text>
                <text fill="#A9F1D7" y={165} x={550} fontSize="12px">
                    {Math.round(first?.total_jump_h) || '0'} سم
                </text>
            </g>

            <g className={`transition-all duration-500 ${animationClass}`}>
                <path d="M38.5802 16.7924C33.9402 16.7924 30.1602 13.0231 30.1602 8.3962C30.1602 3.76931 33.9402 0 38.5802 0C43.2202 0 47.0003 3.76931 47.0003 8.3962C47.0003 13.0231 43.2202 16.7924 38.5802 16.7924ZM38.5802 0.997173C34.4902 0.997173 31.1602 4.31776 31.1602 8.3962C31.1602 12.4746 34.4902 15.7952 38.5802 15.7952C42.6702 15.7952 46.0003 12.4746 46.0003 8.3962C46.0003 4.31776 42.6702 0.997173 38.5802 0.997173Z" fill="white" />
                <path d="M38.5802 0.997173C34.4902 0.997173 31.1602 4.31776 31.1602 8.3962C31.1602 12.4746 34.4902 15.7952 38.5802 15.7952C42.6702 15.7952 46.0003 12.4746 46.0003 8.3962C46.0003 4.31776 42.6702 0.997173 38.5802 0.997173Z" fill="white" />
                <path d="M38.2802 63.8187C37.9002 63.8187 37.5102 63.7589 37.1302 63.6292C36.1902 63.3201 35.4302 62.662 34.9902 61.7745L29.8202 51.2743L14.6901 42.7484C12.4701 41.502 11.6501 38.7498 12.8201 36.4862L16.4301 29.5159L7.78005 36.6856C7.14005 37.3138 6.20004 37.6529 5.27003 37.613C4.33003 37.5631 3.45002 37.1144 2.85002 36.3865C1.73001 35.0303 1.86001 33.016 3.14002 31.8094L17.6301 20.6311H3.37002C1.51001 20.6311 0 19.1254 0 17.2707V17.0712C0 15.2165 1.51001 13.7107 3.37002 13.7107H27.0202C27.7802 13.7107 28.5402 13.96 29.1502 14.4187L34.1202 18.1482C34.8402 18.6866 35.3002 19.4744 35.4202 20.3619C35.5402 21.2494 35.3002 22.1269 34.7502 22.8349L27.5802 32.0388L36.4102 34.3821L48.9803 42.1102C49.8303 42.6387 50.4203 43.4664 50.6403 44.4436C50.8503 45.4209 50.6603 46.418 50.1003 47.2557L49.8903 47.5648C48.8203 49.1603 46.6803 49.6489 45.0103 48.6916L33.9602 42.2997H29.5902L35.9802 47.4252L41.5503 58.5437C42.4403 60.3186 41.7303 62.5024 39.9602 63.4099C39.4302 63.6891 38.8602 63.8187 38.2802 63.8187ZM19.5601 25.617L19.5526 25.6315L13.7001 36.9449C12.7801 38.7298 13.4301 40.8937 15.1801 41.8809L30.5802 50.5563L35.8902 61.3357C36.2102 61.9839 36.7602 62.4625 37.4502 62.6819C38.1302 62.9113 38.8602 62.8514 39.5102 62.5124C40.7903 61.8443 41.3103 60.2588 40.6603 58.9724L35.1402 47.9537L26.7302 41.2926H34.2402L45.5203 47.8141C46.7303 48.5121 48.2803 48.1531 49.0603 46.9964L49.2703 46.6873C49.6803 46.079 49.8103 45.361 49.6603 44.6431C49.5003 43.9351 49.0803 43.3268 48.4603 42.9479L35.9502 35.2597L25.8702 32.6072L33.9602 22.2166C34.3502 21.718 34.5102 21.1098 34.4302 20.4816C34.3502 19.8533 34.0202 19.3149 33.5202 18.9359L28.5502 15.2065C28.1102 14.8774 27.5702 14.6979 27.0202 14.6979H3.37002C2.06001 14.6979 1.00001 15.755 1.00001 17.0612V17.2607C1.00001 18.567 2.06001 19.624 3.37002 19.624H20.5501L3.78002 32.5773C2.91002 33.3949 2.82002 34.8109 3.61002 35.7682C4.04002 36.2867 4.64003 36.5959 5.31003 36.6258C5.97004 36.6657 6.62004 36.4264 7.10004 35.9577L19.5526 25.6315L19.5701 25.617H19.5601Z" fill="white" />
                <path d="M19.5526 25.6315L19.5601 25.617H19.5701L19.5526 25.6315L13.7001 36.9449C12.7801 38.7298 13.4301 40.8937 15.1801 41.8809L30.5802 50.5563L35.8902 61.3357C36.2102 61.9839 36.7602 62.4625 37.4502 62.6819C38.1302 62.9113 38.8602 62.8514 39.5102 62.5124C40.7903 61.8443 41.3103 60.2588 40.6603 58.9724L35.1402 47.9537L26.7302 41.2926H34.2402L45.5203 47.8141C46.7303 48.5121 48.2803 48.1531 49.0603 46.9964L49.2703 46.6873C49.6803 46.079 49.8103 45.361 49.6603 44.6431C49.5003 43.9351 49.0803 43.3268 48.4603 42.9479L35.9502 35.2597L25.8702 32.6072L33.9602 22.2166C34.3502 21.718 34.5102 21.1098 34.4302 20.4816C34.3502 19.8533 34.0202 19.3149 33.5202 18.9359L28.5502 15.2065C28.1102 14.8774 27.5702 14.6979 27.0202 14.6979H3.37002C2.06001 14.6979 1.00001 15.755 1.00001 17.0612V17.2607C1.00001 18.567 2.06001 19.624 3.37002 19.624H20.5501L3.78002 32.5773C2.91002 33.3949 2.82002 34.8109 3.61002 35.7682C4.04002 36.2867 4.64003 36.5959 5.31003 36.6258C5.97004 36.6657 6.62004 36.4264 7.10004 35.9577L19.5526 25.6315Z" fill="white" />
            </g>

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.79867e-07 174.009C1.70072e-07 172.904 0.971785 172.009 2.17054 172.009L557.829 172.009C559.028 172.009 560 172.904 560 174.009C560 175.113 559.028 176.009 557.829 176.009L2.17054 176.009C0.971786 176.009 5.89662e-07 175.113 3.79867e-07 174.009Z"
                fill="#28DC9C"
            />
        </svg>)
};
export default SVGComponent;
